<template>
  <div class="header-box mb10">
    <div class="header-label-box">
      <span class="header-label">{{ project.项目名称 }}</span> <span class="header-label">{{ project.部门 }}</span>
      <span class="header-label">{{ project.客户公司 }}</span>
      <el-rate v-model="project.优先级" class="mr5" disabled text-color="#ff9900"></el-rate>
    </div>
    <div class="header-step-box">
      <div v-for="item in steps" :key="item" :class="[stepMap[step] === item ? 'gray' : 'gray-light', 'header-step']">
        <span class="header-step-name" style="width:76px">{{ item }}</span>
        <div class="header-triangle"><div class="header-triangle-inside"></div></div>
      </div>
      <peixun v-if="peixunType" :type="peixunType" style="display:inline-block;position:relative;top:5px;"></peixun>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    project: { type: Object, default: () => ({}) },
    step: { type: String, default: '' },
  },
  data() {
    return {
      steps: ['寻访沟通', '简历推荐', '安排面试', 'offer谈判', '离职管理', '开票催款'],
      stepMap: {
        人才搜索: '寻访沟通',
        职位推荐: '简历推荐',
        面试阶段: '安排面试',
        offer谈判: 'offer谈判',
        离职管理: '离职管理',
        开票催款: '开票催款',
      },
    }
  },
  computed: {
    projectStep() {
      const label = this.stepMap[this.project.项目阶段]
      return this.steps.findIndex(v => v === label)
    },
    peixunType() {
      const typeMap = {
        离职管理: '12',
        offer谈判: '11',
        面试阶段: '8',
      }
      return typeMap[this.step] || ''
    }
  },
  watch: {
    step: {
      handler(newValue, oldValue) {
        console.log(newValue)
      },
      immediate: true,
    },
  },
}
</script>
<style scoped>
.header-box {
  display: flex;
  font-size: 14px;
}
.header-label-box {
  font-size: 16px;
  display: flex;
  align-items: center;
}
.header-label {
  margin-right: 5px;
  font-weight: 700;
}
.header-step:nth-child(1) {
  margin-left: 0;
}
.header-step {
  display: flex;
  margin-left: -14px;
  float: left;
}
.header-step-name {
  text-align: center;
  color: #808080;
}

.header-step:before {
  content: '';
  display: block;
  width: 0;
  height: 0;
  border-bottom: 20px solid #fff;
  border-right: 0;
  border-left: 20px solid transparent;
  border-top: 0;
}
.header-triangle {
  display: block;
  width: 0;
  height: 0;
  border-top: 20px solid #fff;
  border-left: 0;
  border-right: 20px solid transparent;
  border-bottom: 0;
  position: relative;
}

.header-triangle-inside {
  position: absolute;
  top: -20px;
  left: 0px;
  border-left: 0;
  border-top: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 0;
}
.gray .header-step-name {
  background-color: #ecf5ff;
  color: #52a8e8;
}
.gray.header-step:before {
  border-bottom-color: #ecf5ff;
}
.gray .header-triangle-inside {
  border-top-color: #ecf5ff;
}

.gray-light .header-step-name {
  background-color: #efefef;
}
.gray-light.header-step:before {
  border-bottom-color: #efefef;
}
.gray-light .header-triangle-inside {
  border-top-color: #efefef;
}

.green .header-step-name {
  background-color: #46db78;
}
.green.header-step:before {
  border-bottom-color: #46db78;
}
.green .header-triangle-inside {
  border-top-color: #46db78;
}

.orange .header-step-name {
  background-color: #ff9933;
}
.orange.header-step:before {
  border-bottom-color: #ff9933;
}
.orange .header-triangle-inside {
  border-top-color: #ff9933;
}
</style>
